import React from 'react'
import { CustomerSelect } from './CustomerSelect'
import { SelectAsyncCreatable } from '@ztechapps/webui.input'
import type { CustomerSelectCreatableProps } from '@ztechapps/webui.contract'

export const CustomerSelectCreatable = ({ showInfo = true, ...rest }: CustomerSelectCreatableProps) => {
  return <CustomerSelect {...rest} showInfo={showInfo} As={SelectAsyncCreatable} />
}
